import { AxiosError, AxiosPromise, AxiosResponse } from 'axios'
import { Delete } from './Delete'
import { Filter } from './Devices'
import { Get } from './Get'
import { UserProfileObject } from './organization.types'
import { Post } from './Post'
import { Put } from './Put'
export interface RolesResponse {
  id: string
  name: string
  normalizedName: string
  concurrencyStamp: string
  roleName: string
  newRolename: string
}
class RolesServiceController {
  private licenseManagerUrl =
    process.env.LICENSE_MANAGER_URL ??
    window.location.protocol +
      '//' +
      window.location.hostname +
      '/license_manager'

  private rolesServerUrl = `${this.licenseManagerUrl}/roles`

  public Put = {
    updateRolesInfo: (data: { roleName: string; newRolename: string }) => {
      return Put(this.rolesServerUrl, data)
    },
  }

  public Get = {
    getAllRoles: () => {
      const url = `${this.rolesServerUrl}`
      //console.log('getAllRoles url:', url)
      return Get(url)
    },
  }

  public Post = {
    addRoles: (rolesName: string) => {
      const url = `${this.rolesServerUrl}/${rolesName}`
      return Post(url)
    },
  }

  public Delete = {
    removeRoles: (rolesName: string) => {
      const url = `${this.rolesServerUrl}/${rolesName}`
      return Delete(url)
    },
  }
}

export const RolesService = new RolesServiceController()
